export class FbSwitchButtonConfiguration {

    constructor(public label: string, public onChangeFunction: Function) {
    }

    public static create = (label: string, onChangeFunction: Function) => new FbSwitchButtonConfiguration(label, onChangeFunction);

    setLabel(value: string) {

        this.label = value;
        return this;

    }

}
